// Import the Login component which contains the login form and logic
import Login from '../components/auth/Login';

// LoginPage component: a simple wrapper page for the Login form
function LoginPage() {
  return (
    // Container div to center and add padding to the login form
    <div className="container mx-auto p-4">
      {/* Render the Login form component */}
      <Login />
    </div>
  );
}
// Export the LoginPage as the default export for routing
export default LoginPage;
